export default "__VITE_ASSET__61572b71__"